import React, { useState } from 'react'

import { OrderPopover } from '@components/common/OrderPopover'
import { StatusTag } from '@components/common/StatusTag'
import { Tooltip } from '@components/common/Tooltip'
import { Loading } from '@fourthwall/components'

import { useOrderTimelineEvents } from '../../../Order'
import type { Order } from '../../types'

type TableStatusTagProps = {
  orderId: string
  status: Order['status']
  onTooltipOpen?: () => void
  onTooltipClose?: () => void
}

export const TableStatusTag = ({
  orderId,
  status,
  onTooltipOpen,
  onTooltipClose,
}: TableStatusTagProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const { timelineEvents, isLoading } = useOrderTimelineEvents(orderId, { enabled: isOpen })

  const handleTooltipOpen = () => {
    setIsOpen(true)
    onTooltipOpen?.()
  }

  const handleTooltipClose = () => {
    setIsOpen(false)
    onTooltipClose?.()
  }

  if (!orderId) {
    return <StatusTag status={status} />
  }

  return (
    <Tooltip
      placement="bottom-start"
      size="medium"
      onOpen={handleTooltipOpen}
      onClose={handleTooltipClose}
      content={
        <Loading isLoading={isLoading} size="medium">
          <OrderPopover events={isLoading ? undefined : timelineEvents} />
        </Loading>
      }
    >
      <StatusTag status={status} hoverable />
    </Tooltip>
  )
}
